import React from 'react';
import {Button} from 'react-bootstrap';
export default props => {
  const {isUpdating, initialize, selected, updateMatches, isMatching} = props;
  const handleClick = () => updateMatches(selected);
  return (
    <div className="controls">
      <Button bsStyle="info" disabled={isUpdating} onClick={initialize}>
        Refresh
      </Button>
      
      <Button bsStyle="primary" onClick={handleClick} disabled={isMatching}>
        { isMatching ? 'Running...' : 'Run Matching' }
      </Button>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/vacancies/Controls.jsx